import script from "./watch-sport-live-tv-page.vue?vue&type=script&setup=true&lang=js"
export * from "./watch-sport-live-tv-page.vue?vue&type=script&setup=true&lang=js"

import "./watch-sport-live-tv-page.vue?vue&type=style&index=0&id=796fe8fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796fe8fd"]])

export default __exports__